import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { ReconcilableResponse } from '@features/paymentReconciliationModal/query-api'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { APIError } from '../../../utils'
import { markBankLinesAsPrivate } from '../query-api'

interface UseMarkBankLineAsPrivateProps {
  onSuccess?: (data: ReconcilableResponse) => void
  onError?: (errorMessage: string) => void
}

export const useMarkBankLineAsPrivate = (props?: UseMarkBankLineAsPrivateProps) => {
  const { onSuccess, onError } = props || {}
  const { t } = useTranslation()
  const { organization } = useUserOrganization()

  const { mutate, isLoading: isProcessing } = useMutation(markBankLinesAsPrivate, {
    onSuccess,
    onError: (error: APIError) => {
      onError?.(error?.message || t('something_went_wrong'))
    },
  })

  const markAsPrivate = useCallback(
    (bankLineIds: string[]) => {
      if (!organization?.id) {
        return
      }

      mutate({ organizationId: organization.id, bankLineIds })
    },
    [organization?.id, mutate],
  )

  return { markAsPrivate, isProcessing }
}
